import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/prazo?${serialize(filtros)}`, { tela: 'prazo' })
}

export async function get (id) {
  return httpAuth.get(`/prazo/${id}`, { tela: 'prazo' })
}

export async function add (dados) {
  return httpAuth.post(`/prazo`, dados, { funcionalidade: 'prazo_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/prazo/${id}`, dados, { funcionalidade: 'prazo_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/prazo/${id}`, { funcionalidade: 'prazo_excluir' })
}
